import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { InputSearchComponent } from './input-search.component';
import { TranslateModule } from '@ngx-translate/core';

const COMPONENTS = [InputSearchComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [...COMPONENTS],
})
export class InputSearchModule {}
